import { styled as r } from "styled-components";
import { Colors as o } from "../../../../styles/colors/index.js";
import { Avatar as a } from "../../../../components/Avatar/index.js";
import { AvatarSkeletonContainer as t } from "../../../../components/Avatar/style.js";
const d = r.div`
  grid-area: avatar;
  cursor: pointer;
`, p = r(a)`
  img {
    border: 1px solid rgb(${o.Silver});
    border-radius: 50%;
  }
`;
r(t)`
  grid-area: avatar;
  margin-right: 4px;
`;
export {
  d as CommentAvatarContainer,
  p as CustomAvatar
};
